export enum CategoryType {
    CHANNEL = "channel",
    GALLERY = "gallery",
}

export enum GenieContextType {
    ENTRY = "entry",
    CATEGORY = "category",
    ANCESTOR = "ancestor-category",
}

export interface CategoryData {
    id: number;
    name: string;
    type: CategoryType;
}

export interface BaseSettingsParams {
    ks: string;
    partnerId: number;
    agentMode: boolean;
    categoryData?: CategoryData;
    categoryUrl: string;
}

export interface GenieContextParams {
    entryId?: string;
    categoryData?: CategoryData;
    isAncestorType: boolean;
}

export interface BaseGenieProps {
    ks: string;
    categoryData?: CategoryData;
    isAncestorType?: boolean;
    agentMode?: boolean;
    entryId?: string;
    visualType?: string;
}
